export default function PleasurePage() {
  return (
    <div
      className="relative w-full font-saol h-screen bg-cover bg-center"
      style={{ backgroundImage: "url('/bbb.webp')" }} // замените на ваш путь
    >
      {/* Overlay (если хочешь затемнение — убери комментарий ниже) */}
      {/* <div className="absolute inset-0 bg-black bg-opacity-40 z-0" /> */}

      <div className="absolute inset-0 z-10 flex flex-col md:flex-row p-6 md:p-20">
        {/* Left Text */}
        <div className="flex-1 flex items-start justify-start">
          <h1 className="text-white font-saol text-4xl md:text-7xl lg:text-[90px] leading-none whitespace-pre-line">
            {`Meant to be\nFully\nExperienced!`}
          </h1>
        </div>

        {/* Right Description */}
        <div className="flex-1 flex items-end justify-end text-right">
          <p className="text-white text-sm md:text-base max-w-md leading-relaxed">
            NAMMOS DUBAI AT THE FOUR SEASONS RESORT AT JUMEIRAH BEACH HAS ALREADY ESTABLISHED A GRAND PRESENCE IN MIDDLE EASTERN LUXURY LIFESTYLE, AS A PLACE TO CELEBRATE LIFE; LIFE AS IT IS AND LIFE AS IT CAN BE AT ITS BEST.
          </p>
        </div>
      </div>
    </div>
  );
}
